export default {"src":"/_next/static/media/deco_three_giftboxes.acd104e6.svg","height":61,"width":131,"blurWidth":0,"blurHeight":0};